import { useState, useCallback } from 'react';
import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../constants';

import {
  APIResponseApplicationsType,
  TApplicationsProps,
} from './fetch-applications.types';

export const useAPIFetchApplications = (): APIResponseApplicationsType => {
  const { data, response, get, error, loading } = useFetch(API_ROUTES.APPLICATIONS, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  async function fetchApplications(params: TApplicationsProps): Promise<void> {
    const queryParams = new URLSearchParams(params).toString();
    const data  = await get(`?${decodeURIComponent(queryParams)}`);

    return data;
  }

  return {
    data: data?.data,
    loading,
    error,
    loaded: response?.ok,
    fetchApplications,
  };
};
